export const UPDATE_USER = 'UPDATE_USER'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
